// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jK4x","col":"styles_col__1m5I-"};